exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2ewA5 {\n  height: 340px;\n  overflow: auto;\n  padding: 20px;\n}\n.uFyXh {\n  text-align: center;\n  padding: 15px;\n}\n", ""]);

// Exports
exports.locals = {
	"container": "_2ewA5",
	"button": "uFyXh"
};